<template>
    <div>
        <button v-if="$can('skip-milestones')" @click="skipAll" class="btn btn-brand pull-right m-3">{{ uLang('app.skip_all_milestones') }} <i class="fa fa-step-forward fa-lg pointer"></i></button>
        <v-server-table :url="url" :columns="columns" :options="options" class="trigger" ref="table">
            <template slot="milestone_name" slot-scope="props">
                <router-link :to="{ name: 'admin.relations.trajectory-enrolments.milestone-progresses.view', params: {
                        relationId: relation.id, trajectoryEnrolmentId: trajectoryEnrolment.id, milestoneProgressId: props.row.id }}">
                    {{ props.row.milestone.name }}
                </router-link>
            </template>
            <template slot="remaining_days" slot-scope="props">
                <span>{{ moment(props.row.milestone_end_date).isValid() ? moment(props.row.milestone_end_date).fromNow() : '...' }}</span>
            </template>
        </v-server-table>
    </div>
</template>

<script>
    import Actions from './actions'
    import { TableMixin } from '~/mixins'
    import { ConfirmationAlert, SuccessAlert, ErrorAlert } from '~/Swals';

    export default {
        name: 'index',
        mixins: [ TableMixin ],
        props: {
            relation: {
                type: Object,
                required: true,
            },
            trajectoryEnrolment: {
                type: Object,
                required: true,
            },
            url: {
                type: String,
                required: true,
                default: null,
            }
        },

        data () {
            return {
                columns: [
                    'milestone_name',
                    'remaining_days',
                    'actions',
                ],
                filterable: [
                    'milestone_name',
                ],
                templates: {
                    actions: Actions,
                },
                options: {
                    headings: {
                        milestone_name: this.uLang('app.milestone'),
                        remaining_days: this.uLang('app.expiration_date'),
                        actions: this.uLang('app.actions'),
                    },
                },
            }
        },

        methods: {
            skipAll() {
                new ConfirmationAlert({text: this.uLang('app.skip_all_milestones_question')})
                    .show()
                    .then(async () => {
                        this.commitSkipAll()
                    });
            },

            commitSkipAll() {
                window.axios.put(
                    route('relations.trajectory-enrolments.milestone-progresses.skip', {
                        milestone_progress: 'all',
                        trajectory_enrolment_id: this.trajectoryEnrolment.id,
                    }),
                    {}
                ).then(() => {
                    new SuccessAlert({
                        title: uLang('app.milestones'),
                        text: this.uLang('app.milestone_progresses_skipped')
                    }).show();
                    vue.$emit('reloadTable');
                }).catch(({response}) => {
                    this.handleError(response);
                })
            },

            handleError(response) {
                if (response.status === 403) {
                    response.data.message = 'U heeft geen rechten voor deze actie op dit traject.';
                }

                new ErrorAlert({
                    text: response.data.message
                }).show();
            },
        }
    }
</script>

<style lang="css" scoped>
</style>
